import { DownArrow } from 'assets'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getVideoLineChartAction } from 'store/action/videoReducer'
import { getEmotionFColor, getEmotionIcon, getEmotionSColor } from 'utils/getEmotionIcon'

function VideoLineChart() {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails, videoLineChartData, videoDetailsLoader } = videoRedux

   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData

   const [emotionType, setEmotionType] = useState('positive')

   const params = useParams()

   const [isActiveDate, setIsActiveDate] = useState('5day')
   const dispatch = useDispatch()

   useEffect(() => {
      if (videoDetails?.video_id && selectedChannelID && !videoDetailsLoader) {
         dispatch(
            getVideoLineChartAction({
               video_id: videoDetails?.video_id,
               channel_id: selectedChannelID,
               period_type: isActiveDate
            })
         )
      }
      return () => {}
   }, [videoDetails, isActiveDate, videoDetailsLoader])

   return (
      <div className={videoLineChartData ? '' : ''}>
         <div className="chart-section"></div>
         <div className="card">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 ">
               <div>
                  <p className="at-text-dark at-font-20">Emotions</p>
                  <p className="at-text-light mt-2 at-font-14">
                     Tracks changes over a specific period
                  </p>
               </div>
               <div className="filter-section">
                  <div className="date-filter me-3 ">
                     <div
                        className={`month-title-wrap ${isActiveDate === '5day' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('5day')
                        }}>
                        5D
                     </div>
                     <div
                        className={`month-title-wrap ${isActiveDate === 'day' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('day')
                        }}>
                        D
                     </div>
                     <div
                        className={`month-title-wrap ${isActiveDate === 'week' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('week')
                        }}>
                        W
                     </div>
                     <div
                        className={`month-title-wrap ${isActiveDate === 'month' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('month')
                        }}>
                        M
                     </div>
                  </div>
               </div>
            </div>

            <div>
               <div className="emotion-filter filter-section">
                  <div className="date-filter me-3 ">
                     <div
                        className={`month-title-wrap ${
                           emotionType === 'positive' ? 'active' : ''
                        } `}
                        onClick={() => {
                           setEmotionType('positive')
                        }}>
                        Positive
                     </div>
                     <div
                        className={`month-title-wrap ${emotionType === 'neutral' ? 'active' : ''} `}
                        onClick={() => {
                           setEmotionType('neutral')
                        }}>
                        Neutral
                     </div>
                     <div
                        className={`month-title-wrap ${
                           emotionType === 'negative' ? 'active' : ''
                        } `}
                        onClick={() => {
                           setEmotionType('negative')
                        }}>
                        Negative
                     </div>
                     <div
                        className={`month-title-wrap ${emotionType === 'all' ? 'active' : ''} `}
                        onClick={() => {
                           setEmotionType('all')
                        }}>
                        All
                     </div>
                  </div>
               </div>
               {videoLineChartData && (
                  <VLineChart isActiveDate={isActiveDate} emotionType={emotionType} />
               )}
            </div>
         </div>
      </div>
   )
}

export default VideoLineChart

const getMergedEmotionData = (
   selection,
   positive = [],
   negative = [],
   neutral = [],
   isActiveDate
) => {
   // Select the arrays based on the selection parameter
   let combinedData
   if (selection === 'all') {
      combinedData = [
         ...positive.map((item) => ({ ...item, type: 'positive' })),
         ...negative.map((item) => ({ ...item, type: 'negative' })),
         ...neutral.map((item) => ({ ...item, type: 'neutral' }))
      ]
   } else if (selection === 'positive') {
      combinedData = positive.map((item) => ({ ...item, type: 'positive' }))
   } else if (selection === 'negative') {
      combinedData = negative.map((item) => ({ ...item, type: 'negative' }))
   } else if (selection === 'neutral') {
      combinedData = neutral.map((item) => ({ ...item, type: 'neutral' }))
   } else {
      return { result: [], labels: [] }
   }

   const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

   // Map each emotion and its counts
   const result = combinedData.map(({ emotion, datewise_counts }) => ({
      name: capitalize(emotion),
      data: datewise_counts.map(({ count }) => count)
   }))
   const type = combinedData.map(({ type }) => ({
      type: type
   }))

   // let label

   // label =
   //    isActiveDate === '5day' || isActiveDate === 'day'
   //       ? Array.from(
   //            new Set(
   //               combinedData.flatMap(({ datewise_counts }) =>
   //                  datewise_counts.map(({ date }) =>
   //                     date?.toString()?.toLocaleLowerCase() === 'beyond'.toLocaleLowerCase()
   //                        ? date
   //                        : dayjs(date).format('DD-MMM')
   //                  )
   //               )
   //            )
   //         )
   //       : Array.from(
   //            new Set(
   //               combinedData.flatMap(({ datewise_counts }) =>
   //                  datewise_counts.map(({ date }) => date)
   //               )
   //            )
   //         )
   const label = Array.from(
      new Set(
         combinedData.flatMap(({ datewise_counts }) => datewise_counts.map(({ date }) => date))
      )
   )

   return { result, label, type }
}

const VLineChart = ({ emotionType, isActiveDate }) => {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails, videoLineChartData } = videoRedux

   const [series, setSeries] = useState([])
   const [labels, setLabels] = useState([])
   const [options, setOptions] = useState(null)
   const [visibleSeries, setVisibleSeries] = useState([])
   const [typeStore, setTypeStore] = useState(null)

   useEffect(() => {
      if (videoDetails) {
         const mergedData = getMergedEmotionData(
            emotionType,
            videoLineChartData?.positive,
            videoLineChartData?.negative,
            videoLineChartData?.neutral,
            isActiveDate
         )

         if (mergedData) {
            const gradientColors = { start: [], end: [] }

            mergedData.result?.forEach((item, i) => {
               const emotionName = item?.name
               const emotionType = mergedData?.type[i]
               gradientColors.start.push(getEmotionFColor(emotionName, emotionType.type))
               gradientColors.end.push(getEmotionSColor(emotionName, emotionType.type))
            })

            setOptions({
               fill: {
                  type: 'gradient',
                  gradient: {
                     shade: 'dark',
                     type: 'horizontal',
                     shadeIntensity: 0.5,
                     gradientToColors: gradientColors.end,
                     inverseColors: false,
                     opacityFrom: 0.9,
                     opacityTo: 0.5,
                     stops: [0, 100]
                  }
               },
               colors: gradientColors.start,
               chart: {
                  type: 'line',
                  height: 350,
                  zoom: { enabled: false },
                  toolbar: { show: false },
                  foreColor: '#fff'
               },
               stroke: {
                  curve: 'smooth',
                  width: 2
               },
               dataLabels: { enabled: false },
               markers: { hover: { sizeOffset: 4 } },
               legend: { show: false }, // Turn off the default legend
               grid: { show: false },
               tooltip: { enabled: true, theme: 'dark' },
               xaxis: {
                  categories: labels, // Ensure you pass the correct labels
                  labels: {
                     show: true,
                     rotate: -45, // Rotating labels to avoid overlap
                     // rotateAlways: true,
                     offsetX: 4, // Adjust if necessary
                     offsetY: 2 // Adjust the Y positioning to give space at the bottom
                  }
               }
            })
            setSeries(mergedData.result || [])
            setLabels(mergedData.label || [])
            setTypeStore(mergedData.type)
            setVisibleSeries(mergedData.result.map(() => true)) // Set all series visible initially
         }
      } else {
         setSeries([])
         setLabels([])
      }
   }, [emotionType, videoDetails, videoLineChartData])

   // Toggle visibility for a series
   const toggleSeriesVisibility = (index) => {
      setVisibleSeries((prev) => {
         const updated = [...prev]
         updated[index] = !updated[index]
         return updated
      })
   }

   return (
      <div>
         {options && series && (
            <>
               <div id="chart">
                  <ReactApexChart
                     options={{
                        ...options,
                        labels: labels || []
                     }}
                     series={series.map((s, i) => (visibleSeries[i] ? s : { ...s, data: [] }))}
                     height={350}
                  />
               </div>

               {/* Custom Legend */}
               <div className="custom-legend">
                  {series.map((item, index) => (
                     <div
                        className="custom-legend-wrap"
                        key={index}
                        onClick={() => toggleSeriesVisibility(index)}>
                        <div className="icon-wrap icon-emotion-chart">
                           {getEmotionIcon(item.name, typeStore[index]?.type)}
                        </div>
                        <span
                           className={`chart-emotion-name ${
                              visibleSeries[index] ? 'at-text-dark' : 'at-text-light'
                           }`}>
                           {item.name}
                        </span>
                        {/* <div className="icon-wrap">
                           <DownArrow />
                        </div> */}
                     </div>
                  ))}
               </div>
            </>
         )}
      </div>
   )
}
